import {
  createEstablishment,
  disableEstablishmentById,
  editEstablishment,
  enableEstablishmentById,
} from '@establishment/services/establishmentsService';

import { AxiosResponse } from 'axios';
import EstablishmentMutationPayload from '@establishment/models/dto/establishment-mutation.dto';
import { useMutation } from '@tanstack/react-query';

export const useEnableEstablishment = () => {
  const useEnablEstablishmentMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => enableEstablishmentById(mutationVariables.id));

  return useEnablEstablishmentMutation;
};

export const useDisableEstablishment = () => {
  const useEnablEstablishmentMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string; sendEmail: boolean },
    unknown
  >((mutationVariables) =>
    disableEstablishmentById(mutationVariables.id, mutationVariables.sendEmail),
  );

  return useEnablEstablishmentMutation;
};

export const useCreateEstablishmentRequest = () => {
  const useCreateEstablishmentMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { formData: FormData },
    unknown
  >((mutationVariables) => createEstablishment(mutationVariables.formData));

  return useCreateEstablishmentMutation;
};

export const useEditEstablishmenRequest = () => {
  const useEditEstablishmenMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string; formData: FormData | EstablishmentMutationPayload },
    unknown
  >(({ formData, id }) => editEstablishment(id, formData));

  return useEditEstablishmenMutation;
};
